import React from 'react';

/**
 * CommunityTabs Component
 * Tab navigation without icons
 */
const CommunityTabs = ({ activeTab, onTabChange, isSticky = false }) => {
  const tabs = [
    { id: 0, name: 'Updates' },
    { id: 1, name: 'Events' },
    { id: 2, name: 'Classes' },
    { id: 3, name: 'Prayer' }
  ];
  
  return (
    <div className={`community-tabs ${isSticky ? 'sticky' : ''}`}>
      <div className="community-tabs-row">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`community-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="community-tab-text">{tab.name}</span>
            {activeTab === tab.id && <div className="community-tab-underline" />}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CommunityTabs;
